/**
 * Discrete color blocks for picking — same grid on desktop and mobile,
 * instead of the native OS wheel.
 */

function hslToHex(h, s, l) {
  const hue = ((h % 360) + 360) % 360;
  const sat = Math.max(0, Math.min(1, s));
  const light = Math.max(0, Math.min(1, l));
  const c = (1 - Math.abs(2 * light - 1)) * sat;
  const x = c * (1 - Math.abs(((hue / 60) % 2) - 1));
  const m = light - c / 2;
  let r = 0;
  let g = 0;
  let b = 0;
  if (hue < 60) {
    r = c;
    g = x;
  } else if (hue < 120) {
    r = x;
    g = c;
  } else if (hue < 180) {
    g = c;
    b = x;
  } else if (hue < 240) {
    g = x;
    b = c;
  } else if (hue < 300) {
    r = x;
    b = c;
  } else {
    r = c;
    b = x;
  }
  const toByte = (ch) =>
    Math.round((ch + m) * 255)
      .toString(16)
      .padStart(2, "0");
  return `#${toByte(r)}${toByte(g)}${toByte(b)}`;
}

const GRAYS = [1, 0.94, 0.88, 0.75, 0.6, 0.45, 0.3, 0.15, 0].map((light) =>
  hslToHex(0, 0, light)
);

const HUES = [0, 18, 32, 48, 60, 90, 145, 175, 200, 220, 250, 280, 320];
const LIGHTS = [0.88, 0.74, 0.58, 0.42, 0.28];
const SAT = 0.78;

const CHROMA = HUES.flatMap((hue) => LIGHTS.map((light) => hslToHex(hue, SAT, light)));

/** Curated block colors, neutrals first then hue columns. */
export const COLOR_BLOCKS = [...GRAYS, ...CHROMA];
